export default __webpack_public_path__ + "static/media/Frame-1.2c20076c.svg";